const config = {
  loginUrl: process.env.REACT_APP_LOGIN_URL || "",
  loginUrl2: process.env.REACT_APP_LOGIN_URL_2 || "",
  signupLoginUrl:
    process.env.REACT_APP_SIGNUP_LOGIN_URL ||
    process.env.REACT_APP_LOGIN_URL ||
    "",
  docsUrl: process.env.REACT_APP_DOCS_URL || "",
};

export default config;
